import React, { useState, useCallback } from 'react';
import { useInitTranslations } from 'js/hooks/i18n';
import withField from '../withField';
import DateSpanDisplay from './DateSpanDisplay';
import Picker from './Picker';
import translations from './translations';
import { UNLIMITED } from './constants';

export const useTogglePicker = ({ input, setIsOpened }) => {
    const { onFocus, onBlur } = input;

    return useCallback((val) => {
        const onToggle = val ? onFocus : onBlur;

        if (onToggle) {
            onToggle();
        }

        setIsOpened(val);
    }, [onFocus, onBlur, setIsOpened]);
};

export const usePickerActions = ({ togglePicker, input, unlimitedValue, valueRatio }) => ({
    onClick: useCallback(() => togglePicker(true), [togglePicker]),
    onClose: useCallback(() => togglePicker(false), [togglePicker]),
    onSubmit: useCallback((innerValue) => {
        const { onChange } = input;

        const value = innerValue === UNLIMITED
            ? unlimitedValue
            : Math.floor(innerValue / valueRatio);

        if (onChange) {
            onChange(value);
        }

        togglePicker(false);
    }, [togglePicker, input, unlimitedValue, valueRatio])
});

export const DateSpanPicker = ({
    /* user provided props */
    title = '',
    useDays = true,
    useHours = true,
    useMinutes = true,
    maxDays = 31,
    maxHours = 24,
    maxMinutes = 60,
    // value = 0, ???
    unlimitedValue = UNLIMITED,
    allowUnlimited = true,
    valueRatio = 60000,

    /* rff render props */
    input,
    meta,

    ...rest
}) => {
    const [isOpened, setIsOpened] = useState(false);
    const togglePicker = useTogglePicker({ input, setIsOpened });
    const { onClick, onClose, onSubmit } = usePickerActions({ togglePicker, input, unlimitedValue, valueRatio });
    const { value: outerValue } = input;
    const value = outerValue === unlimitedValue
        ? UNLIMITED
        : outerValue * valueRatio;

    useInitTranslations(translations);

    return (
        <>
            <DateSpanDisplay
                {...{
                    meta,
                    ...rest,
                    useDays,
                    useHours,
                    useMinutes,
                    value,
                    onClick
                }}
            />
            {isOpened && <Picker
                {...{
                    value,
                    onClose,
                    onSubmit,
                    title,
                    useDays,
                    useHours,
                    useMinutes,
                    maxDays,
                    maxHours,
                    maxMinutes,
                    allowUnlimited
                }}
            />}
        </>
    );
};

export default withField(DateSpanPicker);
